import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import { captureLinkToken } from '~/auth/linkToken';
import { redactTokensDeep, scrubReplayRecordingEvent } from '~/sentryScrub';

// Before Sentry.init installs its history instrumentation, so the emailed
// link's `#token=…` is never part of a URL Sentry records.
captureLinkToken();

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: (existingIntegrations) => [
    ...existingIntegrations,
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({ beforeAddRecordingEvent: scrubReplayRecordingEvent }),
  ],
  enabled: import.meta.env.PROD,

  // Any URL that still carries a `token=` value is redacted before it leaves.
  beforeBreadcrumb: (breadcrumb) => redactTokensDeep(breadcrumb),
  beforeSend: (event) => redactTokensDeep(event),
  beforeSendTransaction: (event) => redactTokensDeep(event),

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [import.meta.env.VITE_API_HOST],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
